<template>
  <LoadingState v-if="isLoading()" :size="50" />
  <ErrorState v-else-if="isErrored()" />
  <div v-else-if="isLoaded() && dnsZone">
    <PageTitle>
      <div class="d-flex flex-column">
        <div class="pb-3">{{ getDomain() }}</div>
        <HorizontalList :items="getAttributes()" />
      </div>
      <template #actions>
        <div class="text-right">
          <DropDown :items="getDnsZoneMenuItems()">
            <Btn variant="primary" :disabled="null">
              {{ $t("global.actions") }}
            </Btn>
          </DropDown>
        </div>
      </template>
    </PageTitle>
    <div>
      <DnsZoneAuthoritative />
      <DnsZoneARecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneCnameRecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneMxRecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneNsRecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneTxtRecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneSpfRecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneSrvRecords :dns-zone="dnsZone" class="mb-4" />
      <DnsZoneCaaRecords :dns-zone="dnsZone" />
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import DnsZoneARecords from "@/pages/Dashboard/Dns/DnsZoneARecords";
import DnsZoneAuthoritative from "@/pages/Dashboard/Dns/DnsZoneAuthoritative";
import DnsZoneCaaRecords from "@/pages/Dashboard/Dns/DnsZoneCaaRecords";
import DnsZoneCnameRecords from "@/pages/Dashboard/Dns/DnsZoneCnameRecords";
import DnsZoneDelete from "@/components/smart/modals/DnsZoneDelete";
import DnsZoneGoogleMxRecords from "@/components/smart/modals/DnsZoneGoogleMxRecords";
import DnsZoneMxRecords from "@/pages/Dashboard/Dns/DnsZoneMxRecords";
import DnsZoneNsRecords from "@/pages/Dashboard/Dns/DnsZoneNsRecords";
import DnsZoneSpfRecords from "@/pages/Dashboard/Dns/DnsZoneSpfRecords";
import DnsZoneSrvRecords from "@/pages/Dashboard/Dns/DnsZoneSrvRecords";
import DnsZoneTxtRecords from "@/pages/Dashboard/Dns/DnsZoneTxtRecords";
import DropDown from "@/components/display/DropDown";
import ErrorState from "@/components/display/ErrorState";
import HorizontalList from "@/components/display/HorizontalList";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "DNSZoneDetailPage",
  components: {
    Btn,
    DnsZoneARecords,
    DnsZoneAuthoritative,
    DnsZoneCaaRecords,
    DnsZoneCnameRecords,
    DnsZoneMxRecords,
    DnsZoneNsRecords,
    DnsZoneSpfRecords,
    DnsZoneSrvRecords,
    DnsZoneTxtRecords,
    DropDown,
    ErrorState,
    HorizontalList,
    LoadingState,
    PageTitle,
  },
  props: {
    dnsZoneId: Number,
  },
  setup(props, { root }) {
    const dnsZone = computed(() => store.getters["dnsZones/getItem"]);
    const status = computed(() => store.getters["dnsZones/getItemStatus"]);

    const getAttributes = () => [
      { key: root.$t("global.status"), value: root.$t("global.active") },
    ];

    const getDnsZoneMenuItems = () => {
      return [
        new NavLink(
          root.$t("global.google-mail-records-add"),
          null,
          openAddGoogleMailRecordsForm,
          false,
          "default"
        ),
        new NavLink(root.$t("global.delete"), null, openDeleteForm, false, "danger"),
      ];
    };

    const getDnsZone = () => dnsZone.value;
    const getDomain = () => getDnsZone().domain;
    const getRouterLink = () => ({ name: "dns-zones" });

    const isErrored = () => status.value.isErrored;
    const isLoaded = () => status.value.isLoaded || status.value.isUpdating;
    const isLoading = () => status.value.isLoading || status.value.isUninitialized;

    const openAddGoogleMailRecordsForm = () =>
      store.dispatch("modals/open", {
        template: DnsZoneGoogleMxRecords,
        data: { dnsZone: getDnsZone() },
      });

    const openDeleteForm = () =>
      store.dispatch("modals/open", {
        template: DnsZoneDelete,
        data: { dnsZone: getDnsZone(), redirect: getRouterLink() },
      });

    onMounted(() => {
      store.dispatch("dnsZones/get", props.dnsZoneId);
    });

    return {
      dnsZone,
      getAttributes,
      getDnsZoneMenuItems,
      getDomain,
      isErrored,
      isLoaded,
      isLoading,
    };
  },
};
</script>
